export function getFocusedElementId() {
    return document.activeElement.id
}
export function findElementAndFocus(elemId) {
    let elem = document.getElementById(elemId)
    elem.focus()
}
export function isPromise(func) {
    return func.then && typeof func.then === 'function'
}
export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
export function removeURLParameter(parameter, url = window.location.href) {
    //prefer to use l.search if you have a location/link object
    const urlparts = url.split('?');
    if (urlparts.length >= 2) {

        const prefix = encodeURIComponent(parameter) + '=';
        const pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (let i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}
export function facebookPixel(_eventName) {
    $window.fbq('trackCustom', _eventName, { myParam: _eventName });
}

export function isEditMode() {
    var url = window.location.pathname;
    var filename = url.substring(url.lastIndexOf('/') + 1);
    return (filename == "edit.aspx" || filename == "Edit.aspx");
}

export function getNameByDonationType(type) {

    let typename = null;

    switch (type) {
        case "Single":
            typename = "Single Donation";
            break;
        case "Regular":
            typename = "Monthly Donation";
            break;
        case "Annual":
            typename = "Annual Donation";
            break;
        default:
            typename = "Other Donation";
    }
    return typename;
}

export function getNameByPaymentType(type) {

    let typename = null;

    switch (type) {
        case "wwf_purchasetokenise":
            typename = "Credit card";
            break;
        case "wwf_directdebit":
            typename = "Direct debit";
            break;
        case "wwf_paypal":
            typename = "Paypal";
            break;
        default:
            typename = "Other";
    }
    return typename;
}

export function getProductTypeMapping(type) {
    const lowered = type.toLowerCase();

    switch (lowered) {
        case 'appeal':
        case 'donation': return 'Donate';
        case 'adoption': return 'Adopt';
        default: return type;
    }
}

export function getTaxBrackeList() {
    return [
        { bracket: '$18201 - $45000', tax: '0.19' },
        { bracket: '$45001 - $120000', tax: '0.325' },
        { bracket: '$120001 - $180000', tax: '0.37' },
        { bracket: 'Over $180000', tax: '0.45' }
    ];
}

export function getCountriesList() {

    let countries = require('./store/countries.json');

    return countries;
}
export function getCountriesListForMenu() {
    let countriesForMenu = require('./store/countriesForMenu.json');

    return countriesForMenu;
}

const POSTCODE_RANGES = require('./postcodes.json');

// https://en.wikipedia.org/wiki/Postcodes_in_Australia
export function getAustralianStateByPostcode(postcode) {
    if (isNaN(postcode)) {
        throw new Error('Postcode is not a number');
    }

    postcode = Number(postcode);
    for (const state of Object.keys(POSTCODE_RANGES)) {
        const ranges = POSTCODE_RANGES[state];

        for (const r of ranges) {
            if (postcode >= r[0] && postcode <= r[1]) {
                return state;
            }
        }
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/helpers.js